export enum DocumentLibraryMemberId {
    Preferred_Customer = 17,
    Distributor = 3,
    Novus = 2,
    Retail = 1
}
export enum DisplaySectionId {
    Shopping_Bag = 1,
    Sign_up = 2,
    Profile = 3,
    Payment = 4,
    MyAction_Center = 5,
    Guest_Checkout_Page = 6,
    Retail_Checkout_Page = 7,
    FBO_Checkout_Page = 8,
    FPC_Checkout_Page = 9,
    Payment_Page = 13,
    Member_Info = 14,
    Fbo_Sign_up = 15
}
export enum Portal {
    Account = 3,
    Join = 4,
    Corporate = 1,
    Csp = 5
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/document-library-member-id.enum.ts